import { StandardEvents } from '@shopify/events';

const selector = '[data-lmv-free-shipping-announcement]';

function formatMoney(amount, currency) {
  return new Intl.NumberFormat(document.documentElement.lang || 'en-NZ', {
    style: 'currency',
    currency: currency || 'NZD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(amount);
}

function updateAnnouncement(cart) {
  const message = document.querySelector(selector);
  if (!message || !cart) return;

  const threshold = Number(message.dataset.thresholdCents || 0) / 100;
  const total = Number(cart.cost?.totalAmount?.amount || 0);
  const currency = cart.cost?.totalAmount?.currencyCode || message.dataset.currency || 'NZD';
  if (!threshold) return;

  const remaining = Math.max(0, threshold - total);
  message.textContent = remaining > 0
    ? `You’re ${formatMoney(remaining, currency)} away from free NZ shipping`
    : 'Free NZ shipping unlocked';
}

if (!window.lmvFreeShippingAnnouncementReady) {
  window.lmvFreeShippingAnnouncementReady = true;
  document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
    event.promise?.then(({ cart }) => updateAnnouncement(cart)).catch(() => {});
  });
}
